import { Pagination } from "antd";
import { useEffect, useState } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { changeLoader } from "../../../../redux/reducers/loader";
import { Link } from "react-router-dom";
import { formatDateFunction, getTabFromOrderStatus } from "../../../../utils/helper/utils";

const PaymentReports = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  // const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0); //

  const getAllReports = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      // console.log('apiResponse',apiResponse);
      if (response?.status === 200) {
        let resultData = [];
        if (apiResponse?.data?.data?.data?.length > 0) {
          for (let item of apiResponse?.data?.data?.data) {
            let cardSchemeValue = "";
            if (item?.method === "credit_card" || item?.method === "apple_pay") {
              cardSchemeValue = item?.chargeResponseJson?.card?.scheme;
            } else {
              cardSchemeValue = item?.chargeResponseJson?.paymentBrand;
            }
            resultData.push({
              id: item.id,
              orderNumber: item?.order?.orderNumber,
              transactionId: item?.transactionId,
              firstName: item?.order?.userDetails?.firstName,
              lastName: item?.order?.userDetails?.lastName,
              mobileNo: item?.order?.userDetails?.mobileNo,
              address: item?.order?.addressDetails?.address,
              subTotal: item?.order?.priceDetails?.sub_total,
              couponDiscount: item?.order?.priceDetails?.coupon_discount,
              dropZoneDiscount: item?.order?.priceDetails?.pickup_discount,
              tax: item?.order?.priceDetails?.vat,
              deliveryFees: item?.order?.priceDetails?.delivery_fees,
              shipping: item?.order?.priceDetails?.timeslot_discount,
              amount: item?.amount,
              paymentStatus: item?.paymentStatus,
              method: item?.method,
              transactionDate: item?.createdAt,
              cardScheme: cardSchemeValue,
              status: item?.order?.status,
            });
          }
        }
        setList(resultData);
        setTotalRows(apiResponse?.data?.data?.paginator?.itemCount);
      } else {
        // toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleSort = (column, order) => {
    console.log("column", column, "order", order);
    setInputData((prev) => ({
      ...prev,
      orderBy: column,
      orderType: order,
    }));
  };

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full  text-left	 text-sm  text-gray-500">
          <thead className=" text-gray-700 capitalize text-xs	 bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Order Number <SortingArrow onSort={(order) => handleSort("orderNumber", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Transaction ID <SortingArrow onSort={(order) => handleSort("transactionId", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Customer Information {/* <SortingArrow onSort={(order) => handleSort('firstName',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Customer Billing Address {/* <SortingArrow onSort={(order) => handleSort('address',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Subtotal
                {/* <SortingArrow onSort={(order) => handleSort('sub_total',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Coupon discount
                {/* <SortingArrow onSort={(order) => handleSort('coupon_discount',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Drop zone discount
                {/* <SortingArrow onSort={(order) => handleSort('pickup_discount',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Tax
                {/* <SortingArrow onSort={(order) => handleSort('vat',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Delivery Charges {/* <SortingArrow onSort={(order) => handleSort('timeslot_discount',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Grand Total <SortingArrow onSort={(order) => handleSort("amount", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Payment Status
                <SortingArrow onSort={(order) => handleSort("paymentStatus", order)} />
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Mode of payment
                {/* <SortingArrow onSort={(order) => handleSort('method',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Payment Amount by mode {/* <SortingArrow onSort={(order) => handleSort('',order)} /> */}
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Payment Network
              </th>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                Payment Date
              </th>
            </tr>
          </thead>
          <tbody>
            {list && list.length > 0
              ? list.map((item, index) => {
                  return (
                    <tr key={index} className="bg-white border-b">
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        <Link
                          className="cursor-pointer"
                          to={`/order-management/?order_number=${item?.orderNumber}`}
                          state={{
                            orderNumber: item?.orderNumber,
                            activeTab: getTabFromOrderStatus(item?.status)
                          }}
                          style={{ color: "#37846B", fontWeight: 500 }}
                        >
                          {item?.orderNumber}
                        </Link>
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.transactionId}</td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.firstName} {item?.lastName} | {item?.mobileNo}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">{item?.address}</td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.subTotal}
                        {item?.subTotal ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.couponDiscount}
                        {item?.couponDiscount ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.dropZoneDiscount}
                        {item?.dropZoneDiscount ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.tax}
                        {item?.tax ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.deliveryFees}
                        {item?.deliveryFees ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.amount} {item?.amount ? " SAR" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top">
                        {item?.paymentStatus === "FAILED" ? (
                          <span className="flex items-center bg-[#f2dede] text-[#a94442] text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]">
                            Failed
                          </span>
                        ) : (
                          <span className="flex items-center bg-green-50 text-green-200 text-center px-[12px] py-[8px] rounded w-full max-w-[76px] h-[32px]">
                            Success
                          </span>
                        )}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        Paid via
                        {item?.method === "credit_card" ? " credit card" : ""}
                        {item?.method === "apple_pay" ? " apple pay" : ""}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.method === "credit_card" ? "Credit Card" : ""}
                        {item?.method === "apple_pay" ? "Apple Pay" : ""} - {item?.amount} SAR
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {item?.cardScheme}
                      </td>
                      <td className="px-3 py-4 vertical-top whitespace-nowrap">
                        {formatDateFunction(item?.transactionDate, "dd/mm/yyyy")}
                      </td>
                    </tr>
                  );
                })
              : null}
            {/* Manage developer side */}
            {/* <tr>
              <td colSpan={13} className="text-center mt-3">
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>

      <div className="text-right mt-4">
        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) => setPaginationModel((prev) => ({ ...prev, page: page }))}
              onShowSizeChange={(current, size) => setPaginationModel((prev) => ({ ...prev, limit: size }))}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};
export default PaymentReports;
